import React from 'react';
import { Route, NotFound } from 'cccisd-laravel-boilerplate';
import { Switch } from 'react-router-dom';
import { AdminRoutes, Manage as AppdefManage } from 'cccisd-laravel-appdefs';
import { AuthRedirect } from 'cccisd-laravel-nexus';
import { Quest, AssignmentPlanPlayer, DeploymentPlayer, DataBrowser } from 'cccisd-laravel-assignment';
import { ResourceCenter } from 'cccisd-laravel-resources';
import SecureMessagingLearner from './components/SecureMessaging/SecureMessagingLearner';
import SecureMessagingSiteAdmin from './components/SecureMessaging/SecureMessagingSiteAdmin';
import SecureMessagingInstructor from './components/SecureMessaging/SecureMessagingInstructor';

// Layouts
import MainLayout from './layouts/MainLayout';
import QuestLayout from './layouts/QuestLayout';

// Pages
/* eslint-disable import/no-extraneous-dependencies, import/no-unresolved */
import Welcome from './pages/Welcome';
import PrintView from './pages/PrintView';

// Laravel packages
import Nexus from 'bundle-loader?lazy!cccisd-laravel-nexus';

// Bind MainLayout by default
const AppRoute = p => <Route layout={MainLayout} {...p} />;

const MainLayoutFluid = p => <MainLayout className="container-fluid" {...p} />;
const MainLayoutSecondaryNav = p => <MainLayout showSecondaryNav {...p} />;
const MainLayoutFluidSecondaryNav = p => <MainLayout className="container-fluid" showSecondaryNav {...p} />;

let Fortress = window.cccisd.fortress;
let AppDefinitions = window.cccisd.appDefs;

const componentMatch = {
    AppdefManage,
    DataBrowser,
    Welcome,
    ResourceCenter,
    SecureMessagingLearner,
    SecureMessagingSiteAdmin,
    SecureMessagingInstructor,
};

const layoutMatch = {
    MainLayout,
    MainLayoutFluid,
    MainLayoutSecondaryNav,
    MainLayoutFluidSecondaryNav,
};

export default () => (
    <Switch>
        {AppDefinitions.routes.map(route => {
            const Component = componentMatch[route.componentHandle];
            if (!Component) {
                return null;
            }

            return (
                <AppRoute
                    key={route.handle}
                    path={route.url}
                    component={Component}
                    componentProps={route.componentProps}
                    exact
                    layout={
                        'layout' in route && layoutMatch[route.layout] ? layoutMatch[route.layout] : MainLayoutFluid
                    }
                />
            );
        })}
        <AppRoute path="/" component={Welcome} exact />
        <AppRoute path="/welcome" component={Welcome} />
        <AppRoute path="/printView" component={PrintView} />
        <AppRoute path="/resource-center" component={ResourceCenter} componentProps={{ handle: 'public' }} />
        <AppRoute path="/assignmentPlanPlayer" component={AssignmentPlanPlayer} layout={QuestLayout} />
        <AppRoute
            path="/deploymentPlayer"
            component={DeploymentPlayer}
            layout={QuestLayout}
            componentProps={{
                deploymentHandle: 'deploymentPlayer',
                pawnId: Fortress.user.acting.id === 1 ? null : Fortress.user.acting.id,
                pawnHash: Fortress.user.acting.id === 1 ? null : Fortress.user.acting.random_hash,
            }}
        />
        <AppRoute
            path="/forceSpanish"
            component={DeploymentPlayer}
            layout={QuestLayout}
            componentProps={{
                deploymentHandle: 'forceSpanish',
                pawnId: Fortress.user.acting.id === 1 ? null : Fortress.user.acting.id,
                pawnHash: Fortress.user.acting.id === 1 ? null : Fortress.user.acting.random_hash,
                language: 'es',
            }}
        />

        <AppRoute path={['/quest/preview', '/d', '/survey']} component={Quest} layout={QuestLayout} />

        {/* Laravel packages routes */}
        {AdminRoutes(MainLayoutFluid)}

        <AppRoute
            path="/account"
            layout={null}
            component={Nexus}
            componentProps={{ defaultLayout: MainLayout, registrationSurveyLayout: QuestLayout }}
        />

        <AppRoute path={Fortress.settings.config.after_login_url} component={AuthRedirect} exact />

        {/* Not found page */}
        <AppRoute component={NotFound} />
    </Switch>
);
